import { SxProps, Theme } from '@mui/material';
import { CrmColors } from '../../crm-theme';

/// A lista ocupa a altura que sobra na tela; quem rola é o corpo da tabela.
export const paperSx = (height: number | null): SxProps<Theme> => ({
    width: '100%',
    height: height ?? undefined,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
});

export const TABLE_CONTAINER_SX: SxProps<Theme> = { flex: 1, minHeight: 0, overflow: 'auto' };

export const TABLE_HEAD_SX: SxProps<Theme> = {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: 'background.card',
};

export const ROW_SX: SxProps<Theme> = { cursor: 'pointer', '& > td': { whiteSpace: 'nowrap' } };

/// Folga entre Valor e Responsável para o número não encostar no avatar.
export const VALUE_CELL_SX = { paddingRight: '24px' };
export const OWNER_CELL_SX = { paddingLeft: '24px' };

/// Área com ação própria dentro da linha (dono, compromisso, conversa); sem ação, só agrupa o conteúdo.
export const cellActionSx = (cc: CrmColors, clickable: boolean, gap: number, color?: string): SxProps<Theme> => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap,
    maxWidth: '100%',
    borderRadius: '8px',
    mx: -0.75,
    px: 0.75,
    py: 0.25,
    color,
    ...(clickable && { cursor: 'pointer', '&:hover': { bgcolor: cc.countBg } }),
});

export const leadValueSx = (cc: CrmColors, closed: boolean): SxProps<Theme> => ({
    color: closed ? cc.eventSuccess : cc.textPrimary,
    fontWeight: 700,
    fontVariantNumeric: 'tabular-nums',
});
